// MSMEOperationalGamesHome.jsx
import React, { useState } from 'react';
import GanitaGrid from './GanitaGrid';
import GanitKoshi from './GanitKoshi';
import SetuGrid from './SetuGrid';
import ChitraLogic from './ChitraLogic';

const categories = [
  { 
    id: 1, 
    title: 'Ganita Grid', 
    desc: 'Sum-based logic puzzle that strengthens operational calculation skills.', 
    component: <GanitaGrid />
  },
  { 
    id: 2, 
    title: 'Ganit-Koshi', 
    desc: 'Arithmetic + strategy puzzle that trains problem-solving abilities.', 
    component: <GanitKoshi /> 
  },
  { 
    id: 3, 
    title: 'SetuGrid', 
    desc: 'Connect islands logically without crossing lines. Boosts process planning.', 
    component: <SetuGrid /> 
  },
  { 
    id: 4, 
    title: 'Chitra-Logic', 
    desc: 'Reveal hidden pictures using logic clues. Enhances operational visualization.', 
    component: <ChitraLogic /> 
  },
];

export default function MSMEOperationalGamesHome() {
  const [activeGame, setActiveGame] = useState(null);

    if (activeGame) {
    return (
      <div className="p-5 bg-black min-h-screen text-gray-300">
        {activeGame.component}
      </div>
    );
  }

  return (
    <div className="bg-black min-h-screen p-5 flex flex-col items-center text-gray-300">
      <h1 className="text-2xl font-bold mb-4 text-gray-300">
        ⚙️ Operational Problem Solving Games
      </h1>

      <div className="grid gap-4 w-full max-w-5xl sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {categories.map(cat => (
          <div
            key={cat.id}
            className="flex flex-col justify-between bg-gray-900 rounded-xl p-4 shadow-md hover:shadow-lg transition"
          >
            <h3 className="text-lg font-semibold text-gray-100 mb-2">{cat.title}</h3>
            <p className="text-sm text-gray-400 flex-grow mb-4">{cat.desc}</p>

            <button
              onClick={() => setActiveGame(cat)}
              className="mt-auto px-4 py-2 rounded-lg bg-green-600 text-black font-semibold hover:bg-green-500 transition"
            >
              ▶ Play
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
